<p-dataView [value]="pixelIntegrations" [paginator]="false" layout="grid">
    <!-- <ng-template pTemplate="header">
        <div class="flex justify-end">
            <p-dataViewLayoutOptions class="flex mb-2 mr-2"></p-dataViewLayoutOptions>
        </div>
    </ng-template> -->

    <!-- <ng-template pTemplate="listItem" let-pixel>
        <div class="col-12 cursor-pointer" (click)="openPixelDialog(pixel)">
            <div class="flex flex-column md:flex-row align-items-center p-3 w-full h-60">
                <img [src]="pixel.logo" [alt]="pixel.name" class="my-4 md:my-0 w-4rem mr-5" />
                <div class="flex-1 flex flex-column align-items-left text-left md:text-left">
                    <div class="flex justify-content-between align-items-center w-full">
                        <div class="font-bold text-2xl">{{ pixel.name }}</div>
                        <p-tag *ngIf="pixel.isPinned" severity="info" [rounded]="true" value="Instalado"></p-tag>
                    </div>
                    <div class="mb-2">{{ pixel.description }}</div>
                    <div class="flex align-items-center mt-2">
                        <i class="pi pi-tag mr-2"></i>
                        <span class="font-semibold">{{ pixel.category }}</span>
                    </div>
                </div>
            </div>
        </div>
    </ng-template> -->

    <ng-template pTemplate="gridItem" let-pixel>
        <div class="col-12 lg:col-3 md:col-4 cursor-pointer" (click)="openPixelDialog(pixel)">
            <div
                class="card border-1 surface-border flex flex-column justify-between overflow-hidden ss-l-height">
                <div class="flex flex-column align-items-center text-center flex-1">
                    <div class="relative mb-4 w-2 h-2 md:w-2 md:h-2 lg:w-2 lg:h-2 flex justify-content-center align-items-center overflow-hidden"
                        style="height: 50px;width: 50px !important;">
                        <img [src]="pixel.logo" [alt]="pixel.name" class="max-w-full max-h-full object-contain" />
                    </div>
                    <div class="text-2xl font-bold flex-shrink-0 flex flex-wrap text-center align-items-center justify-content-center gap-2 leading-tight">
                        {{ pixel.name }}
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</p-dataView>

<p-dialog [baseZIndex]="100" class="ss-l-sizeDialogs ss-g-dialog-sized" header="Facebook Pixel" [(visible)]="facebookPixel"
    [modal]="true" id="dialog1" [dismissableMask]="true">
    <p-table [value]="filteredPixels" [lazy]="true" (onLazyLoad)="loadPixelsLazy($event)" [paginator]="true"
        [rowsPerPageOptions]="[10, 20, 100]" [loading]="loadingPixelsTable" [rows]="10" [totalRecords]="totalRecords"
        class="w-full" [scrollable]="true" scrollHeight="flex">

        <ng-template pTemplate="caption">
            <div class="caption-container">
                <button pButton pRipple label="Adicionar" (click)="openAddPixel()"
                    class="p-button-primary-500 text-white b1 mb-2 mx-0 w-full"></button>
            </div>
        </ng-template>

        <ng-template pTemplate="header">
            <tr>
                <th>Nome</th>
                <th>Pixel ID</th>
                <th>Ações</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-rowData>
            <tr *ngIf="!loadingPixels; else loadingContent">
                <td>{{ rowData.key }}</td>
                <td>{{ rowData.pixel_id }}</td>
                <td class="centered-content-sales">
                    <div class="flex">
                        <button pButton pRipple type="button" icon="pi pi-pencil" class="mr-2 mt-3"
                            (click)="editPixel(rowData.id)"></button>
                        <button pButton pRipple type="button" icon="pi pi-trash" class="p-button-danger mt-3"
                            (click)="confirmDeletionPixel(rowData.id)"></button>
                    </div>
                </td>
            </tr>
            <ng-template #loadingContent>
                <tr>
                    <td><p-skeleton></p-skeleton></td>
                    <td><p-skeleton></p-skeleton></td>
                    <td><p-skeleton></p-skeleton></td>
                </tr>
            </ng-template>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="3" class="text-center">Nenhum pixel adicionado.</td>
            </tr>
        </ng-template>
    </p-table>

    <ng-template pTemplate="footer">
        <button pButton pRipple (click)="closeFacebookPixel()" label="Fechar" class="p-button-outlined"></button>
    </ng-template>
</p-dialog>

<p-dialog [baseZIndex]="101" class="ss-l-sizeDialogs ss-g-dialog-sized" (onHide)="onDialogPixelClose()" id="dialog1"
    header="{{ isEditing ? 'Editar' : 'Adicionar' }} Facebook Pixel" [(visible)]="addPixelDialog" [modal]="true"
    [dismissableMask]="true" >
    <div class="card shadow-none" style="max-width: 55vh !important;">
        <div class="mb-4 surface-border border-0 border-bottom-1">
            <div class="mb-2">
                <label for="pixelName" class="w-full ss-g-globalClassLabel">Nome do Pixel</label>
                <input id="pixelName" type="text" pInputText class="w-full mt-2" placeholder="ex: Nome"
                    (click)="forceFocus($event)" [(ngModel)]="formData.key" [ngModelOptions]="{standalone: true}"
                    [ngClass]="{'ng-invalid': hasErrorNamePixel, 'ng-dirty': hasErrorNamePixel}" maxlength="50">
            </div>
            <div class="flex align-items-center justify-content-between">
                <small *ngIf="hasErrorNamePixel" class="p-error">
                    Obrigatório
                </small>
            </div>
            <div class="mb-2">
                <label for="pixelId" class="w-full ss-g-globalClassLabel">Pixel ID</label>
                <input id="pixelId" type="text" pInputText class="w-full mt-2" placeholder="ex: ID" maxlength="50"
                    (click)="forceFocus($event)" [(ngModel)]="formData.pixel_id" [ngModelOptions]="{standalone: true}"
                    [ngClass]="{'ng-invalid': hasErrorIdPixel, 'ng-dirty': hasErrorIdPixel}">
            </div>
            <div class="flex align-items-center justify-content-between">
                <small *ngIf="hasErrorIdPixel" class="p-error">
                    Obrigatório
                </small>
            </div>
            <div class="mb-4">
                <label for="accessToken" class="w-full ss-g-globalClassLabel">Access Token</label>
                <input id="accessToken" type="password" pInputText class="w-full mt-2" placeholder="ex: Access Token"
                    (click)="forceFocus($event)" [(ngModel)]="formData.access_token" [ngModelOptions]="{standalone: true}">
            </div>
        </div>

        <div class="surface-border border-0">
            <p class="mb-2">Eventos de visualização</p>
            <div class="flex align-items-center gap-2 mb-2">
                <p-inputSwitch binary="true" class="mr-2 ss-l-switch-position3"
                    [(ngModel)]="formData.view_events.fb_pixel_view.view_events.ss_view_percentage"
                    [ngModelOptions]="{standalone: true}"></p-inputSwitch>
                <label class="flex-1">A cada 5% de vídeo assistido</label>
                <i class="bi bi-info-circle ml-1"
                    pTooltip="Enviado a cada 5% de vídeo assistido. Chega à Meta via Conversions API como evento personalizado chamado 'ss_view_percentage', visível no Gerenciador de Eventos em 'Eventos personalizados'. Ideal para criar públicos segmentados por nível de engajamento com o conteúdo."
                    tooltipPosition="left"></i>
            </div>
            <div class="flex align-items-center gap-2 mb-2">
                <p-inputSwitch binary="true" class="mr-2 ss-l-switch-position3"
                    [(ngModel)]="formData.view_events.fb_pixel_view.view_events.ss_pitch_hit"
                    [ngModelOptions]="{standalone: true}"></p-inputSwitch>
                <label class="flex-1">Ao chegar ao <b>Pitch</b></label>
                <i class="bi bi-info-circle ml-1"
                    pTooltip="Enviado quando o vídeo atinge o momento de pitch — o ponto configurado onde o produto é apresentado. Chega à Meta como evento personalizado 'ss_pitch_hit'. Indica audiência de alto interesse, ideal para públicos de remarketing mais qualificados do que simples visualizadores."
                    tooltipPosition="left"></i>
            </div>
            <div class="flex align-items-center gap-2 mb-2">
                <p-inputSwitch binary="true" class="mr-2 ss-l-switch-position3"
                    [(ngModel)]="formData.view_events.fb_pixel_view.view_events.ss_product_view"
                    [ngModelOptions]="{standalone: true}"></p-inputSwitch>
                <label class="flex-1">Ao detalhar produto</label>
                <i class="bi bi-info-circle ml-1"
                    pTooltip="Enviado ao abrir os detalhes de um produto, com SKU, nome e preço. Chega à Meta como o evento padrão 'ViewContent', visível em 'Eventos padrão' no Gerenciador de Eventos. Permite otimizar campanhas por visualização de produto e criar públicos de remarketing de catálogo."
                    tooltipPosition="left"></i>
            </div>
            <div class="flex align-items-center gap-2 mb-2">
                <p-inputSwitch binary="true" class="mr-2 ss-l-switch-position3"
                    [(ngModel)]="formData.view_events.fb_pixel_view.view_events.ss_like"
                    [ngModelOptions]="{standalone: true}"></p-inputSwitch>
                <label class="flex-1">Ao dar like</label>
                <i class="bi bi-info-circle ml-1"
                    pTooltip="Enviado quando o usuário curte o vídeo. Chega à Meta como evento personalizado 'ss_like', visível em 'Eventos personalizados' no Gerenciador de Eventos. Use para criar públicos de quem demonstrou aprovação explícita do conteúdo."
                    tooltipPosition="left"></i>
            </div>
            <div class="flex align-items-center gap-2 mb-2">
                <p-inputSwitch binary="true" class="mr-2 ss-l-switch-position3"
                    [(ngModel)]="formData.view_events.fb_pixel_view.view_events.ss_cta_click"
                    [ngModelOptions]="{standalone: true}"></p-inputSwitch>
                <label class="flex-1">Ao clicar em CTAs</label>
                <i class="bi bi-info-circle ml-1"
                    pTooltip="Enviado ao clicar em um botão de call-to-action no vídeo. Chega à Meta como evento personalizado 'ss_cta_click'. Use para criar públicos de quem demonstrou intenção de compra mas ainda não adicionou ao carrinho."
                    tooltipPosition="left"></i>
            </div>
            <div class="flex align-items-center gap-2 mb-2">
                <p-inputSwitch binary="true" class="mr-2 ss-l-switch-position3"
                    [(ngModel)]="formData.view_events.fb_pixel_view.view_events.ss_redirect"
                    [ngModelOptions]="{standalone: true}"></p-inputSwitch>
                <label class="flex-1">Ao redirecionar a página</label>
                <i class="bi bi-info-circle ml-1"
                    pTooltip="Enviado quando o usuário é encaminhado para a página de destino (ex: loja). Chega à Meta como evento personalizado 'ss_redirect'. Representa o momento de saída do vídeo em direção à compra — útil para medir o tráfego gerado pelo conteúdo."
                    tooltipPosition="left"></i>
            </div>
            <div class="flex align-items-center gap-2 mb-0">
                <p-inputSwitch binary="true" class="mr-2 ss-l-switch-position3"
                    [(ngModel)]="formData.view_events.fb_pixel_view.view_events.ss_share"
                    [ngModelOptions]="{standalone: true}"></p-inputSwitch>
                <label class="flex-1">Ao compartilhar a página</label>
                <i class="bi bi-info-circle ml-1"
                    pTooltip="Enviado quando o usuário compartilha o vídeo. Chega à Meta como evento personalizado 'ss_share'. Indica engajamento orgânico alto — use para criar públicos de amplificadores de conteúdo e excluí-los de campanhas de aquisição."
                    tooltipPosition="left"></i>
            </div>
        </div>
        <div class="surface-border border-0 mt-4">
            <p class="mb-2">Eventos de conversão</p>
            <div class="flex align-items-center gap-2">
                <p-inputSwitch binary="true" class="mr-2 ss-l-switch-position3"
                    [(ngModel)]="formData.conversion_events.fb_pixel_conversion.conversion_events.ss_add_to_cart.enabled"
                    [ngModelOptions]="{standalone: true}"></p-inputSwitch>
                <label class="flex-1">Ao adicionar ao carrinho</label>
                <i class="bi bi-info-circle ml-1"
                    pTooltip="Enviado ao adicionar um produto ao carrinho, com SKU, nome, quantidade, preço e moeda (BRL). Chega à Meta como o evento padrão 'AddToCart', visível em 'Eventos padrão' no Gerenciador de Eventos. É o evento mais importante para campanhas de carrinho abandonado e otimização de conversão por catálogo."
                    tooltipPosition="left"></i>
            </div>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <button pButton pRipple (click)="closeAddFacebookPixel()" label="Fechar" class="p-button-outlined"></button>
        <button pButton pRipple label="Salvar" *ngIf="!isEditing" class="ml-2 mr-2" (click)="savePixel()"
            [loading]="savePixelLoading"></button>
        <button pButton pRipple label="Salvar" *ngIf="isEditing" class="ml-2 mr-2" (click)="updatePixel()"
            [loading]="savePixelLoading"></button>
    </ng-template>
</p-dialog>
